<template>
  <div class="eyes">
    <div class="eyes_grid">
      <div v-for="tile in tiles" :key="tile.id" class="eyes_tile">
        <div class="tile_header">
          <h1>{{ tile.title }}</h1>
          <button class="button refresh_button" :disabled="tile.loading" @click="refreshTile(tile.id)">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 8.25C14.6159 5.65466 12.3769 3.75 9.75 3.75C7.32233 3.75 5.23259 5.37697 4.6438 7.62046M3 6V8.25H5.25" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M3 9.75C3.38408 12.3453 5.62314 14.25 8.25 14.25C10.6777 14.25 12.7674 12.623 13.3562 10.3795M15 12V9.75H12.75" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>

        <div class="tile_metrics">
          <div class="tile_metric">
            <span>Active Accounts Count</span>
            <strong>{{ tile.activeAccountsCount }}</strong>
          </div>
          <div class="tile_metric">
            <span>Total Accounts Count</span>
            <strong>{{ tile.totalAccountsCount }}</strong>
          </div>
        </div>

        <div class="tile_actions">
          <button class="button" :disabled="tile.loading" @click="startTile(tile.id)">Start</button>
          <button class="button stop_button" :disabled="tile.loading" @click="stopTile(tile.id)">Stop</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useToast } from "vue-toastification";

export default {
  name: "EyesComponent",
  data() {
    return {
      tiles: [
        {
          id: "padre-eyes",
          title: "Padre Eyes",
          base: 200,
          activeAccountsCount: 0,
          totalAccountsCount: 200,
          running: false,
          loading: false,
        },
      ],
    };
  },
  methods: {
    getTile(id) {
      return this.tiles.find((tile) => tile.id === id);
    },
    getHeaders() {
      return {
        Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
      };
    },
    applyStatus(tile, data) {
      //const base = Number(data?.base ?? 0);
      const active = Number(data?.activeAccounts ?? 0);
      const total = Number(data?.totalAccounts ?? 0);

     // tile.base = Number.isFinite(base) ? base : 0;
      tile.activeAccountsCount =active //Number.isFinite(active + idle) ? active + idle : 0;
      tile.totalAccountsCount = total;
      //tile.running = Boolean(data?.running);
    },
    async refreshTile(id) {
      const tile = this.getTile(id);

      if (!tile) {
        return;
      }

      tile.loading = true;
      try {
        const res = await axios.get(`${process.env.VUE_APP_SERVERHOST}/api/padre-eyes/server-status`, {
          headers: this.getHeaders(),
        });
        this.applyStatus(tile, res.data);
      } catch (error) {
        console.log(error);
        this.toast.error("Failed to refresh eyes status", { timeout: 1500 });
      } finally {
        tile.loading = false;
      }
    },
    async startTile(id) {
      const tile = this.getTile(id);
      if (!tile) {
        return;
      }

      tile.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_SERVERHOST}/api/padre-eyes/startAll`,
          {
          },
          {
            headers: this.getHeaders(),
          }
        );

        this.applyStatus(tile, res.data);
        this.toast.success("Padre Eyes Init started", { timeout: 1500 });
      } catch (error) {
        console.log(error);
        this.toast.error("Failed to start Padre Eyes", { timeout: 1500 });
      } finally {
        tile.loading = false;
      }
    },
    async stopTile(id) {
      const tile = this.getTile(id);
      if (!tile) {
        return;
      }

      tile.loading = true;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_SERVERHOST}/api/padre-eyes/stopAll`,
          {},
          {
            headers: this.getHeaders(),
          }
        );

        this.applyStatus(tile, res.data);
        this.toast.success("Padre Eyes stopped", { timeout: 1500 });
      } catch (error) {
        console.log(error);
        this.toast.error("Failed to stop Padre Eyes", { timeout: 1500 });
      } finally {
        tile.loading = false;
      }
    },
  },
  mounted() {
    this.refreshTile("padre-eyes");
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
};
</script>

<style scoped>
.eyes {
  width: 100%;
  padding: 30px;
}

.eyes_grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: start;
}

.eyes_tile {
  min-height: 260px;
  border: 1px solid #60cb89;
  border-radius: 12px;
  background-color: #191919;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.tile_header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.tile_header h1 {
  font-size: 28px;
  font-family: "Proxima Nova Bold";
}

.refresh_button {
  margin-top: 0;
  padding: 0;
  width: 40px;
  height: 40px;
  background: transparent;
  border: 1px solid #60cb89;
}

.refresh_button svg path {
  stroke: #60cb89;
  transition: 0.2s;
}

.refresh_button:hover svg path {
  stroke: #ffffff;
}

.refresh_button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.tile_metrics {
  display: grid;
  gap: 10px;
  flex: 1;
}

.tile_metric {
  border: 1px solid #60cb8945;
  border-radius: 8px;
  background: #202020;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
}

.tile_metric span {
  color: #a3a3a3;
  font-size: 14px;
}

.tile_metric strong {
  font-size: 20px;
  font-family: "Proxima Nova Bold";
}

.tile_actions {
  display: flex;
  gap: 10px;
  margin-top: auto;
}

.tile_actions .button {
  margin-top: 0;
}

.tile_actions .button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.stop_button {
  background-color: #cb6060;
}

@media (max-width: 768px) {
  .eyes {
    padding: 16px;
  }
  .eyes_grid {
    grid-template-columns: 1fr;
  }
}
</style>
